import { useContext, useEffect, useState } from 'react'
import AuthContext from '../../../contexts/AuthContext';
import { createColumnHelper } from '@tanstack/react-table';
import axios from 'axios';
import showNotification from '../../../utils/showNotification';
import { ERROR_HANDLER } from '../../../utils/error-handler';

export default function useAcademicSubscription() {
   const { authToken } = useContext(AuthContext)
   const [displayForm, setDisplayForm] = useState(false);
   const [initialValuesEdit, setInitialValuesEdit] = useState(null);
   const [deleteModalOpen, setDeleteModalOpen] = useState(false);
   const [selectedSubscriptionId, setSelectedSubscriptionId] = useState(null);
   const [loading, setLoading] = useState(false)
   const [subscriptionData, setSubscriptionData] = useState(null)
   const [isUpdatedData, setIsUpdatedData] = useState(false)

   const columnHelper = createColumnHelper();
   const columns = [
      columnHelper.accessor("name", {
         cell: (info) => {
            return info.getValue();
         },
         header: "Nombre",
         enableColumnFilter: true,
         enableSorting: false,
         filter: "text",
         filterFn: "includesString",
      }),
      columnHelper.accessor("level", {
         cell: (info) => {
            return Number(info.getValue());
         },
         header: "Nivel",
         enableColumnFilter: true,
         enableSorting: false,
         filter: "text",
         filterFn: "includesString",
      }),
      columnHelper.accessor("is_active", {
         cell: (info) => {
            const value = info.getValue()
            return value === true ? "ACTIVA" : "INACTIVA";
         },
         header: "Estado",
         enableColumnFilter: false,
         enableSorting: true,
         filter: "text",
         filterFn: "includesString",
      }),
      columnHelper.accessor("price.usd", {
         cell: (info) => {
            return info.getValue();
         },
         header: "Precio (USD)",
         enableColumnFilter: false,
         enableSorting: true,
         filter: "number",
         filterFn: "includesString",
      }),
      columnHelper.accessor("price.ars", {
         cell: (info) => {
            return info.getValue();
         },
         header: "Precio (ARS)",
         enableColumnFilter: false,
         enableSorting: true,
         filter: "number",
         filterFn: "includesString",
      }),
   ];

   const onCreateInitialValues = {
      name: "",
      level: 1,
      is_active: 'INACTIVA',
      features: [],
      price: {
         usd: 0,
         ars: 0
      }
   }

   useEffect(() => {
      const getSubsciptions = async () => {
         try {
            setLoading(true)

            const { data } = await axios.get(`${process.env.REACT_APP_BACKEND_SERVER}admin/academico/subscriptions`, {
               headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${authToken}`
               }
            })

            setSubscriptionData(data)
         } catch (error) {
            console.log(error)
            showNotification({
               color: "red",
               status: "error",
               title: "Operación fallida.",
               message: `No se pudo crear el plan. Detalle: ${error}`,
               autoClose: 12000,
            });
         } finally {
            setLoading(false)
         }
      }

      getSubsciptions()
   }, [authToken, isUpdatedData])

   const editSubscription = (rowData) => {
      if (rowData) {
         setInitialValuesEdit({
            _id: rowData._id,
            name: rowData.name,
            level: rowData.level,
            price: rowData.price,
            is_active: rowData.is_active ? "ACTIVA" :"INACTIVA",
            features: rowData.features || [],
         });
         setDisplayForm(true);
      }
   };

   const create = async (values, axiosConfig) => {
      await axios.post(
         `${process.env.REACT_APP_BACKEND_SERVER}admin/academico/subscriptions`,
         { data: values },
         axiosConfig
      )
   }
   const edit = async (values, axiosConfig) => {
      const { _id: contentId, ...jsonData } = values

      await axios.put(
         `${process.env.REACT_APP_BACKEND_SERVER}admin/academico/subscriptions`,
         {
            item: {
               _id: contentId
            },
            field: jsonData
         },
         axiosConfig
      )
   }

   // const deleteSubscriptionPlan = async (contentId = null) => {
   //    if (deleteModalOpen) {
   //       try {
   //          setLoading(true);
   //          await axios.delete(
   //             `${process.env.REACT_APP_BACKEND_SERVER}admin/academico/subscription`,
   //             {
   //                headers: {
   //                   "Content-Type": "application/json",
   //                   Authorization: `Bearer ${authToken}`,
   //                },
   //                data: { _id: selectedSubscriptionId._id },
   //             }
   //          );
   //          setIsUpdatedData(!isUpdatedData);
   //          showNotification({
   //             color: "green",
   //             status: "success",
   //             title: "¡Operación exitosa!",
   //             message: "El elemento seleccionado ha sido eliminado correctamente.",
   //             autoClose: 12000,
   //          });
   //       } catch (error) {
   //          console.error(error);
   //          showNotification({
   //             color: "red",
   //             status: "error",
   //             title: "Operación fallida.",
   //             message: `No se pudo eliminar el plan. Detalle: ${ERROR_HANDLER[error.request?.status] || ERROR_HANDLER.defaultError
   //                }`,
   //             autoClose: 12000,
   //          });
   //       } finally {
   //          setDeleteModalOpen(false);
   //          setLoading(false);
   //       }
   //    } else {
   //       setSelectedSubscriptionId(contentId);
   //       setDeleteModalOpen(true);
   //    }
   // };

   const handleSubmit = async (values) => {
      const config = {
         headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
         },
      };

      const jsonData = {
         ...values,
         is_active: values.is_active === 'ACTIVA' ? true : false
      }

      try {
         setLoading(true);
         // Check if it's an edit or a new event
         if (initialValuesEdit) {
            await edit(jsonData, config);
         } else {
            await create(jsonData, config);
         }

         showNotification({
            color: "green",
            status: "success",
            title: "¡Excelente! Operación exitosa.",
            message: `El plan ${values.name} ha sido creado / editado con éxito.`,
         });

         setIsUpdatedData(!isUpdatedData);
      } catch (error) {
         showNotification({
            color: "red",
            status: "error",
            title: "Operación fallida.",
            message: `No se pudo crear / editar el plan. Detalle: ${ERROR_HANDLER[error.request?.status] || ERROR_HANDLER.defaultError
               }`,
            autoClose: 12000,
         });
      } finally {
         setLoading(false);
         setDisplayForm(false);
         setInitialValuesEdit(null);
      }
   };

   return {
      displayForm,
      setDisplayForm,
      initialValuesEdit,
      setInitialValuesEdit,
      deleteModalOpen,
      setDeleteModalOpen,
      selectedSubscriptionId,
      setSelectedSubscriptionId,
      loading,
      setLoading,
      handleSubmit,
      subscriptionData,
      columns,
      editSubscription,
      // deleteSubscriptionPlan,
      onCreateInitialValues
   }

}
